import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/AuthService/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  authService = inject(AuthService);
  constructor(private router: Router) {}

  getNome() {
    const nome = String(localStorage.getItem('nome'));
    return nome.length > 15 ? nome.substring(0, 15) + '...' : nome;
  }

  logout() {
    this.router.navigate(['login']);

    localStorage.clear();
  }
}
